import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from './configureStore';

interface TutorialState {
	activeTutorial: number | null;
}

const initialState: TutorialState = {
	activeTutorial: null,
};

const slice = createSlice({
	name: 'tutorials',
	initialState,
	reducers: {
		setActiveTutorial: (tutorials, action) => {
			tutorials.activeTutorial = action.payload;
		},
	},
});

export const { setActiveTutorial } = slice.actions;

export const getTutorials = createSelector(
	(state: RootState) => state,
	(state) => state.tutorials
);

export default slice.reducer;
